<div id="uploadMultiple">
  <div *ngIf='ShowCardURL && editMode' class="btn-default cardUrlInput margBott16">
    <button type="button" (click)="cardUrlInput()">
      If item selected <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.3335 10.833C8.69138 11.3114 9.14796 11.7073 9.67229 11.9938C10.1966 12.2802 10.7764 12.4506 11.3724 12.4933C11.9683 12.5359 12.5665 12.45 13.1263 12.2411C13.6861 12.0323 14.1944 11.7055 14.6168 11.283L17.1168 8.78298C17.8758 7.99714 18.2958 6.94463 18.2863 5.85214C18.2768 4.75965 17.8386 3.7146 17.0661 2.94207C16.2935 2.16953 15.2485 1.73133 14.156 1.72184C13.0635 1.71234 12.011 2.13232 11.2252 2.89131L9.79183 4.31631M11.6668 9.16631C11.309 8.68787 10.8524 8.29199 10.328 8.00553C9.80371 7.71906 9.22391 7.54871 8.62796 7.50603C8.032 7.46335 7.43384 7.54934 6.87405 7.75816C6.31425 7.96698 5.8059 8.29375 5.3835 8.71631L2.8835 11.2163C2.12451 12.0022 1.70453 13.0547 1.71402 14.1472C1.72352 15.2396 2.16172 16.2847 2.93426 17.0572C3.70679 17.8298 4.75184 18.268 5.84433 18.2775C6.93681 18.2869 7.98932 17.867 8.77517 17.108L10.2002 15.683"
          stroke="#475467" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="col-md-1 col-sm-1 col-xs-1" *ngIf='infoImage && editMode'>
    <button class="ee" matTooltip="Image URl (optional) 128 dp tall x 232 dp wide."
      matTooltipClass="example-tooltip-red" aria-label="Button that displays a tooltip when focused or hovered over"
      class="example-button">
      <span class="material-icons" style="color: #62686b;">
        contact_support
      </span>
    </button>
  </div>


  <div>
    <ng-container *ngIf='!editMode'>
      <ng-container *ngIf='imagelink'>
        <img [src]="imagelink" style="max-width: 100% !important;" />
      </ng-container>
      <ng-container *ngIf='image'>
        <img [src]="image" style="max-width: 100% !important;" />
      </ng-container>
    </ng-container>
    <div class="d-flex w-100 gap-24" *ngIf='imagelink && editMode && !hideUploadUI'>

      <div *ngIf="isUploading" class="loading-container" style="border: 1px solid #D0D5DD;">
        <div class="spinner-box">
          <div class="circle-border"></div>
        </div>
        <div class="progress-text">Uploading... {{progress.percentage}}%</div>
      </div>

      <div class="outputImg d-flex" *ngIf="!isUploading">
        <div class="blocimage flex-direction-initial">
          <div class="affichage">
            <ng-container *ngIf='imagelink'>
              <img [src]="imagelink" style="max-width: 100% !important;" />
            </ng-container>
            <ng-container *ngIf='image'>
              <img [src]="image" style="max-width: 100% !important;" />
            </ng-container>
          </div>

          <div [ngClass]=" imagelink || image ? 'image1n': 'image1'" class="col-md-5 col-sm-5 col-xs-5">

            <div (click)="imgFileInput.click()" class="img1">
              <button type="button" md-button><img src="../../../assets/images/upload.png" /></button>
              <input hidden type="file" #imgFileInput accept='.jpeg, .jpg , .png' (change)="selectFile($event)" />
              <button class="btn-successs" [disabled]="selectedFiles">Upload your image here</button>
            </div>
          </div>
        </div>
      </div>

      <div class="ChangeImg w-100" *ngIf="!isUploading">
        <div class="change text-center" *ngIf='imagelink'>

          <div (click)="imgFileInput.click()" class="img1">
            <button type="button" md-button><img src="../../../assets/images/upload.svg" /></button>
            <input hidden type="file" #imgFileInput (change)="selectFile($event)" accept='.jpeg, .jpg , .png' />
            <button style="color:var(#418987);font-weight: bold;" class="btn-change" [disabled]="selectedFiles">Change
              your
              image</button>
          </div>
          <span class="text-center">Or</span>
          <button class="btn-successs" style="margin-bottom:10px;" (click)="URLInput()"
            [disabled]="selectedFiles">Change image from URL</button>
        </div>
      </div>


    </div>


    <!-- elsee -->
    <ng-container *ngIf='editMode && !hideUploadUI'>
      <div [ngClass]=" imagelink || image ? 'affichage1n': 'affichage1'" style="
   width: 100%;
   margin: 0 auto;
   display: block">
        <div class=" blocimage">

          <div *ngIf="isUploading" class="loading-container">
            <div class="spinner-box">
              <div class="circle-border"></div>
            </div>
            <div class="progress-text">Uploading... {{progress.percentage}}%</div>
          </div>

          <div class="affichage" *ngIf="!isUploading">
            <div *ngIf='imagelink'>
              <img [src]="imagelink" />
            </div>
            <div *ngIf='image'>
              <img [src]="image" />
            </div>

            <div [ngClass]=" imagelink || image ? 'image1n': 'image1'">

              <div (click)="imgFileInput.click()" class="img1">
                <button type="button" md-button><img src="../../../assets/images/upload.svg" /></button>
              </div>
              <div class="d-flex justify-content-center">
                <input hidden type="file" #imgFileInput (change)="selectFile($event)" accept='.jpeg, .jpg , .png' />
                <button (click)="imgFileInput.click()" class="btn-successs" style="margin: 0;
              color:#418987; font-weight: 600;" [disabled]="selectedFiles">Upload your image
                  here</button>

                <span style="color: #5e5e5e!important;">Or</span>
                <button class="btn-successs marg0" (click)="URLInput()" [disabled]="selectedFiles">Add image from
                  URL</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="col-md-1 col-sm-1 col-xs-1" *ngIf='ShowAlt'>
    <div class="alt-image">
      <button type="button" md-button (click)="ALTInput()"><img src="../../../assets/images/alt.png" /></button>
    </div>
  </div>
</div>